/* Botão de som (começa mudo) nos vídeos da seção "Vídeo comprável". Carregado pela própria seção. */
(function () {
  if (window.__svSoundLoaded) return;
  window.__svSoundLoaded = true;

  var ICON_OFF = '<svg class="sv-snd-off" width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M11.5 4.2 7.8 7H5.2A1.2 1.2 0 0 0 4 8.2v3.6A1.2 1.2 0 0 0 5.2 13h2.6l3.7 2.8V4.2Z" fill="currentColor"/><path d="M15 6.5 18 13M18 6.5 15 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_ON = '<svg class="sv-snd-on" width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M11.5 4.2 7.8 7H5.2A1.2 1.2 0 0 0 4 8.2v3.6A1.2 1.2 0 0 0 5.2 13h2.6l3.7 2.8V4.2Z" fill="currentColor"/><path d="M14.6 7.4a3.4 3.4 0 0 1 0 5.2M16.9 5.4a6.4 6.4 0 0 1 0 9.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function setSound(btn, video, on) {
    video.muted = !on;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Desativar o som' : 'Ativar o som');
    if (on) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function muteAllExcept(keep) {
    document.querySelectorAll('.sv-snd').forEach(function (b) {
      if (b !== keep && b.svVideo) setSound(b, b.svVideo, false);
    });
  }

  /* se o card do produto está por cima do vídeo, o botão sobe para ficar acima dele */
  function placeButton(btn, wrap) {
    var card = wrap.closest('.video-item__banner');
    card = card && card.querySelector('.video-item__product');
    btn.style.bottom = (card ? card.offsetHeight + 25 : 12) + 'px';
  }

  function init(scope) {
    (scope || document).querySelectorAll('.video-item__banner video').forEach(function (video) {
      var wrap = video.closest('.video-item__popup-media--ratio');
      if (!wrap || wrap.querySelector('.sv-snd')) return;
      video.muted = true; /* padrão: sem som */
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sv-snd';
      btn.svVideo = video;
      btn.innerHTML = ICON_OFF + ICON_ON;
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Ativar o som');
      btn.addEventListener('click', function (e) {
        e.stopPropagation(); /* não abre o pop-up do vídeo */
        e.preventDefault();
        var turnOn = video.muted;
        if (turnOn) muteAllExcept(btn);
        setSound(btn, video, turnOn);
      });
      wrap.appendChild(btn);
      placeButton(btn, wrap);
      window.addEventListener('resize', function () { placeButton(btn, wrap); });
      window.addEventListener('load', function () { placeButton(btn, wrap); });
      /* ao sair da tela, volta a ficar mudo */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting && !video.muted) setSound(btn, video, false);
        }, { threshold: 0.2 }).observe(video);
      }
    });
  }

  function start() { init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
